
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...refine]]",
      function () {
        return require("private-next-pages/[[...refine]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...refine]]"])
      });
    }
  